const SET_FAVORITE = 'favorite/SET_FAVORITE';
const RESET_FAVORITES = 'favorite/RESET_FAVORITES';

export default {
  SET_FAVORITE,
  RESET_FAVORITES
};
